import ImageIcon from '@mui/icons-material/Image';
import { Card } from 'shared/mui/Card';
import { CircularProgress } from 'shared/mui/CircularProgress/CircularProgress';
import { MethodLogo } from 'types/embedded/methodLogo';

type Props = {
  methodLogo: MethodLogo | undefined;
  isLoadingMethod?: boolean;
  isForm?: boolean;
};

export const GatewayRuleMappingMethod: React.FC<Props> = ({
  methodLogo,
  isLoadingMethod,
  isForm,
}) => {
  const renderImage = () => {
    if (isLoadingMethod) {
      return <CircularProgress size={16} />;
    }
    return !methodLogo?.filePath ? (
      <ImageIcon sx={{ color: 'rgba(0,0,0,0.26)', objectFit: 'contain' }} />
    ) : (
      <img
        alt={methodLogo?.name}
        src={methodLogo?.filePath}
        style={{ width: '48px', height: '48px', objectFit: 'contain' }}
      />
    );
  };

  return (
    <Card
      sx={{
        border: `1px solid ${isForm ? 'rgba(0,0,0,0.23)' : 'rgba(0,0,0,0.12)'}`,
        width: '40px',
        height: '40px',
        minWidth: '40px',
        marginRight: isForm ? 0 : '16px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      {renderImage()}
    </Card>
  );
};
